import React from 'react';

import { Box, Stack } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';
import { cssMap } from '@atlaskit/css';

import { useAudioBriefing } from '../../../../hooks/useAudioBriefing';
import { SourcesPanelRestartButton } from '../../sub-components/RestartButton';

import { AdditionalResourceSelection } from './sub-components/AdditionalResourceSelection';
import { BriefingSourcesInput } from './sub-components/BriefingSourcesInput';

const styles = cssMap({
	container: {
		flex: 1,
	},
	textFieldContainer: {
		flexGrow: 1,
		paddingBlock: token('space.negative.400'),
	},
	restartButtonContainer: {
		marginBlockStart: token('space.150'),
	},
});

export type AudioBriefingPopupSourcesPanelProps = {
	audioRef: React.RefObject<HTMLAudioElement>;
};

export const AudioBriefingPopupSourcesPanel = ({
	audioRef,
}: AudioBriefingPopupSourcesPanelProps) => {
	const [
		{ activeContent, additionalResources, cloudId, hasFetched, isLoading },
		{ addAdditionalResource, removeAdditionalResource },
	] = useAudioBriefing();

	return (
		<Box xcss={styles.container}>
			<Stack space="space.075">
				{additionalResources.map((resource) => (
					<AdditionalResourceSelection
						key={resource.url}
						resource={resource}
						removeResource={removeAdditionalResource}
					/>
				))}
			</Stack>
			<Box xcss={styles.textFieldContainer}>
				<BriefingSourcesInput
					cloudId={cloudId}
					additionalResources={additionalResources}
					addAdditionalResource={addAdditionalResource}
					activeContent={activeContent}
				/>
			</Box>
			{hasFetched && (
				<Box xcss={styles.restartButtonContainer}>
					<SourcesPanelRestartButton audioRef={audioRef} isLoading={isLoading} />
				</Box>
			)}
		</Box>
	);
};
